import { z } from 'zod';

import {
    ANNUAL_CASH_FLOW_VALUES,
    PAYMENT_GATEWAY_CARDS_CONFIG,
} from '../static/formStaticDataConfig';

const isValidNIP = (nip: string): boolean => {
    if (!/^\d{10}$/.test(nip)) return false;

    const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    const digits = nip.split('').map(Number);
    const checksum = digits
        .slice(0, 9)
        .reduce((acc, digit, idx) => acc + digit * (weights[idx] as number), 0);

    return checksum % 11 === digits[9];
};

export const BusinessContactFormSchema = z.object({
    name: z.string().min(1, 'Imię i nazwisko są wymagane'),
    email: z
        .string()
        .min(1, 'Adres e-mail jest wymagany')
        .regex(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            'Adres e-mail nie jest poprawny',
        ),
    phone_number: z
        .string()
        .min(1, 'Numer telefonu jest wymagany')
        .min(9, 'Numer telefonu jest nieprawidłowy (+48 XXXXXXXXX)')
        .max(9, 'Numer telefonu jest nieprawidłowy (+48 XXXXXXXXX)')
        .regex(/^\d{9}$/, 'Numer telefonu jest nieprawidłowy (+48 XXXXXXXXX)'),
    nip: z
        .string()
        .min(10, 'NIP musi mieć dokładnie 10 cyfr')
        .max(10, 'NIP musi mieć dokładnie 10 cyfr')
        .regex(/^\d{10}$/, 'NIP może zawierać tylko cyfry')
        .refine(isValidNIP, 'Niepoprawny numer NIP'),
    website: z.string().min(1, 'Adres strony internetowej jest wymagany'),
    annual_cash_flow: z.enum(ANNUAL_CASH_FLOW_VALUES, {
        required_error: 'Musisz wybrać jedną z opcji',
    }),
    payment_gateway: z.enum(PAYMENT_GATEWAY_CARDS_CONFIG).optional(),
    message: z.string().optional(),
    'g-recaptcha-response': z.string(),
});

export type BusinessContactFormValuesType = z.infer<
    typeof BusinessContactFormSchema
>;
